/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EntityType {
    AgencyGroupUpdate = 'AgencyGroupUpdate',
    AgencyUpdate = 'AgencyUpdate',
    AirlineUpdate = 'AirlineUpdate',
    BookingCreateBookingIdRemarkRuleUpdate = 'BookingCreateBookingIdRemarkRuleUpdate',
    BookingCreateOsisRuleUpdate = 'BookingCreateOsisRuleUpdate',
    BookingCreateSSRRuleUpdate = 'BookingCreateSSRRuleUpdate',
    BrandUpdate = 'BrandUpdate',
    CountryUpdate = 'CountryUpdate',
    DistributionChannelUpdate = 'DistributionChannelUpdate',
    GlobalFilterRuleUpdate = 'GlobalFilterRuleUpdate',
    IdentityProviderSettingsUpdate = 'IdentityProviderSettingsUpdate',
    IdentitySettingsUpdate = 'IdentitySettingsUpdate',
    LocationUpdate = 'LocationUpdate',
    MarketUpdate = 'MarketUpdate',
    MarkupUpdate = 'MarkupUpdate',
    PreferenceRuleUpdate = 'PreferenceRuleUpdate',
    ProviderCredentialUpdate = 'ProviderCredentialUpdate',
    ProviderSearchRuleUpdate = 'ProviderSearchRuleUpdate',
    RegionUpdate = 'RegionUpdate',
    SearchRuleUpdate = 'SearchRuleUpdate',
    StationUpdate = 'StationUpdate',
    TicketTimeLimitOverrideUpdate = 'TicketTimeLimitOverrideUpdate',
    ProviderLocationMapping = 'ProviderLocationMapping',
    ProviderUpdate = 'ProviderUpdate',
    AncillarySupplierUpdate = 'AncillarySupplierUpdate',
    AncillaryDistributionUpdate = 'AncillaryDistributionUpdate',
    VccCredentialsUpdate = 'VccCredentialsUpdate',
    SSRRuleUpdate = 'SSRRuleUpdate',
    BookingToleranceUpdate = 'BookingToleranceUpdate',
    AncillaryUpdate = 'AncillaryUpdate'
}

export function EntityTypeFromJSON(json: any): EntityType {
    return EntityTypeFromJSONTyped(json, false);
}

export function EntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityType {
    return json as EntityType;
}

export function EntityTypeToJSON(value?: EntityType | null): any {
    return value as any;
}

